export default {
    header: "Řády {name}",
    error: "Došlo k chybě",
    empty: "Nenalezeny žádné objednávky",
    system: "Help Desk",
    orders: {
        name: "Jméno",
        date: "Datum",
        status: "Postavení",
        approvedBy: "Schváleno"
    },
    cta: {
        close: "Blízko"
    }
}